import { fixedExpenseTest } from "../utils/bills";
import { isSpending, isEarning } from "../utils/expenseTypes";

const inMonth = (iso, year, month) => {
  const d = new Date(`${iso}T00:00:00`);
  return d.getFullYear() === year && d.getMonth() === month;
};

// A month in numbers: what went out (fixed / random - lent money, loans paid back and
// card bill payments not counted), what came in (not borrowed money), and what was
// left. `month` is 0-11.
export const monthSummary = (bills, income, year, month) => {
  const isFixedExpense = fixedExpenseTest(bills.filter(isSpending));
  const spending = bills.filter((b) => isSpending(b) && inMonth(b.dueDate, year, month));
  const fixed = spending.filter(isFixedExpense).reduce((s, b) => s + b.amount, 0);
  const random = spending.filter((b) => !isFixedExpense(b)).reduce((s, b) => s + b.amount, 0);
  const spent = fixed + random;
  const received = income.filter((i) => isEarning(i) && i.status === "Received" && inMonth(i.date, year, month)).reduce((s, i) => s + i.amount, 0);
  return {
    label: new Date(year, month, 1).toLocaleDateString("en-US", { month: "long" }),
    spent,
    fixed,
    random,
    fixedPct: spent > 0 ? Math.round((fixed / spent) * 100) : 0,
    received,
    saved: received - spent,
  };
};

// One line for a notification. `money` formats an amount (respects "Hide amounts").
export const summaryText = (s, money) =>
  s.spent === 0 && s.received === 0
    ? `Nothing recorded for ${s.label}.`
    : `${money(s.spent)} spent (${s.fixedPct}% fixed), ${money(s.received)} came in, ${s.saved >= 0 ? `${money(s.saved)} saved` : `${money(-s.saved)} more out than in`}.`;
